import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import { isEmpty } from "lodash";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import "assets/scss/table.scss";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getSchemeAnalytesList } from "store/results/actions";
import { getMicroReport } from "store/resultsSubmit/actions";
import { getResultSubmit } from "store/resultsSubmit/actions";
import { getMicroStatisticsList } from "store/results/actions";
import logo from "../../assets/images/LogoNeqas.jpg";
import { propTypes } from "react-bootstrap/esm/Image";

class Results extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      antibioticsData: [],
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      organismList: [
        {
          text: "Organism Detected by Participant",
          dataField: "submitted",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#2791a9ff",
            textAlign: "center",
          }),
          style: { color: "#000000ff" },
          classes: "text-left",
          formatter: (cellContent, row) => (
            <div className="text-left">{row.submitted}</div>
          ),
        },
        {
          text: "Expected Organism",
          dataField: "expected",
          headerStyle: () => ({
            backgroundColor: "#2791a9ff", // full red header
            textAlign: "center",
          }),
          style: { color: "#000000ff" },
          classes: "text-center",
          formatter: (cellContent, row) => (
            <div className="text-center">{row.expected}</div>
          ),
        },

        {
          text: "Organism Score",
          dataField: "organism_score",
          headerStyle: () => ({
            backgroundColor: "#2791a9ff", // full red header
            textAlign: "center",
          }),
          style: { color: "#000000ff" },
          classes: "text-center",
          formatter: (cellContent, row) => (
            <div className="text-center">{row.organism_score}</div>
          ),
        },
      ],
      columnsList: [
        {
          text: "Antibiotic",
          dataField: "antibiotic",
          sort: true,
          headerStyle: () => ({
            backgroundColor: "#2791a9ff", // full red header
            textAlign: "center",
          }),
          style: { color: "#000000ff" },
          classes: "text-left",
          formatter: (cellContent, row) => (
            <div className="text-left">{row.antibiotic}</div>
          ),
        },
        {
          text: "Expected",
          dataField: "expected",
          headerStyle: () => ({
            backgroundColor: "#2791a9ff", // full red header
            textAlign: "center",
          }),
          style: { color: "#000000ff" },
          classes: "text-center",
          formatter: (cellContent, row) => (
            <div className="text-center">{row.expected}</div>
          ),
        },
        {
          text: "Submitted",
          dataField: "submitted",
          headerStyle: () => ({
            backgroundColor: "#2791a9ff", // full red header
            textAlign: "center",
          }),
          style: { color: "#000000ff" },
          classes: "text-center",
          formatter: (cellContent, row) => (
            <div className="text-center">{row.submitted}</div>
          ),
        },

        {
          text: "Antibiotic Score",
          dataField: "antibiotic_value",
          headerStyle: () => ({
            backgroundColor: "#2791a9ff", // full red header
            textAlign: "center",
          }),
          style: { color: "#000000ff" },
          classes: "text-center",
          formatter: (cellContent, row) => (
            <div className="text-center">{row.antibiotic_value}</div>
          ),
        },
      ],
    };
  }

  componentDidMount() {
    const { onGetSchemeAnalyte, onGetReport } = this.props;
    const id = this.props.match.params.id; // roundId
    onGetSchemeAnalyte(id);
    onGetReport(id);
  }

  componentDidUpdate(prevProps) {
    const { Report } = this.props;

    if (Report !== prevProps.Report && !isEmpty(Report)) {
      // ✅ Use participantId from URL instead of logged-in user
      const participantId = parseInt(this.props.match?.params?.id1, 10);

      const participantReport = Report.reports?.find(
        (r) => parseInt(r.participant_id, 10) === participantId
      );

      if (!participantReport?.details) return;

      let organismData = [];
      let antibioticData = [];
      let totalAssignedAntibiotics = 0;
      let totalCorrectAntibiotics = 0;

      // ✅ Merge expected + submitted into single organism row
      if (participantReport.details.length > 0) {
        const combined = participantReport.details.reduce(
          (acc, org) => {
            if (org.expected && org.expected !== "-")
              acc.expected = org.expected;
            if (org.submitted && org.submitted !== "-")
              acc.submitted = org.submitted;

            // take last non-zero score (or keep existing)
            acc.organism_score = org.organism_score || acc.organism_score || 0;

            return acc;
          },
          { expected: "-", submitted: "-", organism_score: 0 }
        );

        organismData.push(combined);
      }

      // ✅ Collect all antibiotics from all detail objects
      participantReport.details.forEach((org) => {
        if (org.antibiotics && org.antibiotics.length > 0) {
          org.antibiotics.forEach((ab) => {
            const expected = (ab.expected || "").toString().trim();
            const submitted = (ab.submitted || "").toString().trim();

            // Skip antibiotics with no expected value
            if (!expected) return;

            // Count totals
            totalAssignedAntibiotics += 1;
            if (expected.toLowerCase() === submitted.toLowerCase()) {
              totalCorrectAntibiotics += 1;
            }

            antibioticData.push({
              organism: org.submitted || org.expected,
              antibiotic: ab.antibiotic,
              expected: expected,
              submitted: submitted || "-",
              status: ab.status,
              antibiotic_value: ab.antibiotic_value,
            });
          });
        }
      });

      // sort antibiotics alphabetically
      antibioticData.sort((a, b) => a.antibiotic.localeCompare(b.antibiotic));

      // calculate organism total score
      const totalOrganismScore = organismData.reduce(
        (sum, item) => sum + (item.organism_score || 0),
        0
      );

      console.log(
        "✅ Totals calculated:",
        totalCorrectAntibiotics,
        totalAssignedAntibiotics
      );

      this.setState({
        organismData,
        antibioticsData: antibioticData,
        totalCorrect: totalOrganismScore,
        totalAssignedAntibiotics,
        totalCorrectAntibiotics,
        totalWrong: participantReport?.total_wrong || 0,
        totalParticipants: Report.reports?.length || 0,
        roundId: Report.round_id,
        schemeName: Report.scheme_name,
        roundNo: Report.round_no,
      });
    }
  }

  handleDownloadPDF = () => {
    const input = document.getElementById("report-area");

    html2canvas(input, {
      scale: 4, // high resolution capture
      ignoreElements: (el) => el.classList.contains("no-print"),
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pageWidth = 210; // A4 width (mm)
      const pageHeight = 297; // A4 height (mm)

      // ✅ Use almost full page width so text is not tiny
      const margin = 10;
      const imgWidth = pageWidth - margin * 2;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = margin; // start with top margin

      // First page
      pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // Additional pages (if content is longer than 1 page)
      while (heightLeft > 0) {
        position = heightLeft - imgHeight + margin;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", margin, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("participant-report.pdf");
    });
  };

  render() {
    const { rounds, issue_date, closing_date, sample, participant_name } =
      this.props;
    const participant_id = this.props.match?.params?.id1 || null;

    const defaultSorted = [
      {
        dataField: "antibiotic",
        order: "asc",
      },
    ];

    return (
      <React.Fragment>
        <style>
          {`
          .table thead th {
            background-color: #6C48C5;
            color: white; 
          }
          .table td {
            text-align: left !important;
          }
          `}
        </style>
        <div className="page-content">
          <MetaTags>
            <title>Microbiology Report</title>
          </MetaTags>
          <div className="d-flex justify-content-end mb-3">
            <Button
              className="btn btn-outline-secondary btn-sm no-print"
              onClick={this.handleDownloadPDF}
            >
              Download
            </Button>
          </div>
          <Container fluid id="report-area">
            <div className="text-center mb-3">
              <img
                src={logo}
                alt="Logo"
                style={{ height: "60px", marginBottom: "10px" }}
              />

              <h4 style={{ fontWeight: "bold", color: "blue" }}>
                NHS - National External Quality Assessment Scheme
              </h4>
            </div>
            <Row className="mb-3 justify-content-center ms-5 ">
              <Col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                className="d-flex flex-wrap align-items-center gap-3 ms-5 "
              >
                {/* <div className="d-flex align-items-center">
                  <span className="me-2 fw-bold">Participant No:</span>
                  <span className="fw-bold">{participant_id}</span>
                </div> */}
                <div className="d-flex align-items-center">
                  <span className="me-2 fw-bold">Participant Name:</span>
                  <span className="fw-bold">
                    {participant_name ? participant_name : "N/A"}
                  </span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="me-2 fw-bold">Round:</span>
                  <span className="fw-bold">{rounds ? rounds : "N/A"}</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="me-2 fw-bold">Sample:</span>
                  <span className="fw-bold">{sample ? sample : "N/A"}</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="me-2 fw-bold">Issue Date:</span>
                  <span className="fw-bold">
                    {moment(issue_date).format("DD-MMM-YY, h:mm A")}
                  </span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="me-2 fw-bold">Closing Date:</span>
                  <span className="fw-bold">
                    {moment(closing_date).format("DD-MMM-YY, h:mm A")}
                  </span>
                </div>
              </Col>
            </Row>

            {/* Organism Table */}
            <Row className="justify-content-center align-items-center">
              <Col xs="12" sm="12" md="12" lg="9">
                <Card>
                  <CardBody>
                    <div className="table-responsive mb-4">
                      <h6>
                        <strong>Organism Score</strong>
                      </h6>
                      <div>
                        Your Organism marks is {this.state.totalCorrect || 0}{" "}
                        out of 50
                      </div>
                      <ToolkitProvider
                        keyField="id"
                        data={this.state.organismData || []}
                        columns={this.state.organismList}
                        search
                      >
                        {(toolkitProps) => (
                          <BootstrapTable
                            id="organism-table"
                            keyField="organism"
                            data={this.state.organismData || []}
                            columns={this.state.organismList}
                          />
                        )}
                      </ToolkitProvider>
                    </div>

                    {/* Antibiotic Table */}
                    {/* Antibiotic Table or Mismatch Message */}
                    {this.state.antibioticsData.length > 0 ? (
                      this.state.organismData?.every(
                        (org) =>
                          org.submitted?.toLowerCase() ===
                          org.expected?.toLowerCase()
                      ) ? (
                        // ✅ Show Antibiotic Table
                        <div className="table-responsive">
                          <h6>
                            <strong>Antibiotic Score</strong>
                          </h6>
                          <ToolkitProvider
                            keyField="antibiotic"
                            data={this.state.antibioticsData}
                            columns={this.state.columnsList}
                            search
                          >
                            {(toolkitProps) => (
                              <BootstrapTable
                                id="antibiotic-table"
                                keyField="antibiotic"
                                responsive
                                bordered={false}
                                striped={false}
                                classes="table table-bordered"
                                {...toolkitProps.baseProps}
                              />
                            )}
                          </ToolkitProvider>
                        </div>
                      ) : (
                        // ❌ Show mismatch message in red
                        <div
                          style={{
                            color: "red",
                            fontWeight: "bold",
                            marginTop: "10px",
                          }}
                        >
                          You detected the wrong organism and your overall Score
                          is 0 out of 50, and your Antibiotic result is also
                          detected as 0.
                        </div>
                      )
                    ) : null}
                  </CardBody>
                </Card>
              </Col>
            </Row>

            {/* Show Antibiotic Results message only if organism matches */}
            {this.state.organismData?.every(
              (org) =>
                org.submitted?.toLowerCase() === org.expected?.toLowerCase()
            ) && (
              <Row className="">
                <Col xs="12" sm="12" md="8" lg="9">
                  <div
                    style={{
                      fontSize: "14px",
                      marginLeft: "100px",
                      color: "#000000",
                    }}
                  >
                    <div>
                      Your Submitted Results for{" "}
                      <strong>{this.state.totalCorrectAntibiotics || 0}</strong>{" "}
                      Antibiotic which have been compared against the defined
                      panel of{" "}
                      <strong>
                        {this.state.totalAssignedAntibiotics || 0}
                      </strong>{" "}
                      correct antibiotics.
                      <Row>
                        <div
                          style={{
                            fontSize: "14px",
                            color: "#000000",
                          }}
                        >
                          Based on this comparison, your AST score is{" "}
                          <strong>
                            (
                            {this.state.totalAssignedAntibiotics
                              ? Math.round(
                                  (this.state.totalCorrectAntibiotics /
                                    this.state.totalAssignedAntibiotics) *
                                    100
                                )
                              : 0}
                            %)
                          </strong>
                        </div>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Results.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,
  SchemeAnalytesList: PropTypes.array,
  Report: PropTypes.object,
  SerologyResult: PropTypes.array,
  rounds: PropTypes.number,
  round_id: PropTypes.number,
  sample: PropTypes.string,
  issue_date: PropTypes.string,
  participant_name: PropTypes.string,
  closing_date: PropTypes.string,
  onGetSchemeAnalyte: PropTypes.func,
  onGetReport: PropTypes.func,
};
const mapStateToProps = ({ ResultSubmit, SchemeAnalytesList }, ownProps) => {
  const participantId = parseInt(ownProps.match?.params?.id1, 10);

  const report = ResultSubmit.MicroReport || {};
  const participantReport = report.reports?.find(
    r => parseInt(r.participant_id, 10) === participantId
  );

  console.log("👉 URL participantId:", participantId);
  console.log("👉 Report participants from API:", report.reports?.map(r => r.participant_id));

  return {
    SchemeAnalytesList: SchemeAnalytesList.SchemeAnalytesList,
    rounds: SchemeAnalytesList.rounds,
    sample: report.sample || "N/A",
    round_id: SchemeAnalytesList.round_id,
    issue_date: SchemeAnalytesList.issue_date,
    closing_date: SchemeAnalytesList.closing_date,
    Report: report,
    participant_name: participantReport?.participant_name || "N/A",
  };
};




const mapDispatchToProps = (dispatch) => ({
  onGetSchemeAnalyte: (id) => dispatch(getSchemeAnalytesList(id)),
  onGetReport: (id) => dispatch(getMicroReport(id)),
  onGetResultSubmit: (id) => dispatch(getResultSubmit(id)),
  onGetStatisticsList: (id) => dispatch(getMicroStatisticsList(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Results));
